import { render, staticRenderFns } from "./CourierSender.vue?vue&type=template&id=5d3655ea&"
import script from "./CourierSender.vue?vue&type=script&lang=js&"
export * from "./CourierSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports